"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _UniqueNodeKeySet_fingerprints;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueNodeKeySet = void 0;
/**
 * Tracks which unique nodes have been seen before.
 * Uses precalculated DedupedNode.fingerprints property to determine uniqueness.
 * DedupedNode.fingerprints is a string[] of stringified target, xpath, and ancestry.
 */
class UniqueNodeKeySet {
    constructor() {
        _UniqueNodeKeySet_fingerprints.set(this, new Map());
        this.getDuplicateFingerprint = (node) => {
            // For the case of Mobile, there are no fingerprints generated
            // TODO: https://github.com/dequelabs/jazzband/issues/2359
            if (!node.fingerprints) {
                return;
            }
            const duplicateFingerprint = node.fingerprints.find(fingerprint => __classPrivateFieldGet(this, _UniqueNodeKeySet_fingerprints, "f").has(fingerprint));
            return duplicateFingerprint
                ? __classPrivateFieldGet(this, _UniqueNodeKeySet_fingerprints, "f").get(duplicateFingerprint)
                : undefined;
        };
        this.upsert = (node) => {
            // For the case of Mobile, there are no fingerprints generated
            // TODO: https://github.com/dequelabs/jazzband/issues/2359
            if (!node.fingerprints) {
                return;
            }
            // This will always be the stringified target selector
            const primaryFingerprint = node.fingerprints[0];
            node.fingerprints.forEach(fingerprint => {
                __classPrivateFieldGet(this, _UniqueNodeKeySet_fingerprints, "f").set(fingerprint, primaryFingerprint);
            });
        };
    }
    static from(result) {
        const uniques = new UniqueNodeKeySet();
        for (const unique of result.uniques) {
            uniques.upsert(unique);
        }
        return uniques;
    }
}
exports.UniqueNodeKeySet = UniqueNodeKeySet;
_UniqueNodeKeySet_fingerprints = new WeakMap();
//# sourceMappingURL=uniqueNodeKeySet.js.map